export type SsoDomainSafeguardEmailSignupPayload = {
  firstName: string;
  lastName: string;
  username: string;
  password: string;
  organization?: string;
  captcha?: string;
  customReferer: string;
  marketingEmails?: boolean;
  acceptTerms?: boolean;
};

// persistableSsoDomainSafeguardEmailPayload strips the one-time captcha token before handing the
// payload to /team-uses-sso navigation state. signupv2 validates captcha on every request, so the
// interstitial must collect a fresh token.
export function persistableSsoDomainSafeguardEmailPayload(
  payload: SsoDomainSafeguardEmailSignupPayload,
): SsoDomainSafeguardEmailSignupPayload {
  const { captcha: _captcha, ...rest } = payload;
  return rest;
}
